module.exports = __webpack_public_path__ + "img/imgpromo.5def3657.png";